<template>
  <div>
    <ui-spinner v-if="loading.view"></ui-spinner>
    <div v-else>
      <p>Calendario:</p>
      <DetailCalendarioComponent 
        :startWeekDay="containers.startWeekDay"
        :numDays="containers.numDays"
        :month="month"
        :idModule="idModule"
        :calendario="containers.calendario"
      />
    </div>
    <hr>
    <p>Resumen:</p>
    <div class="row">
      <div class="col-md-6">
        <div class="table-responsive">
          <table class="table table-sm table-hover table-bordered">
            <thead class="table-secondary">
              <tr class="text-center">
                <td class="align-middle" rowspan="2">Guía</td>
                <td :colspan="idModule == 1 ? 2 : 3">Servicios</td>
                <td class="align-middle" rowspan="2">Total</td>
              </tr>
              <tr class="text-center">
                <td>City</td>
                <td>Valle</td>
                <td v-if="idModule == 2">MaPi</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in resumen" :key="item.name" class="text-center">
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.services.city }}
                </td>
                <td>
                  {{ item.services.valle }}
                </td>
                <td v-if="idModule == 2">
                  {{ item.services.mapi }}
                </td>
                <td>
                  {{ item.total }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DetailCalendarioComponent from '@/views/programacion/guias/DetailCalendarioComponent';
export default {
  props: {
    month: String,
    idModule: Number
  },
  components: {
    DetailCalendarioComponent,
  },
  data () {
    return {
      fd: {
        idGuia: null
      },
      loading: {
        view: true,
      },
      containers: {
        calendario: [],
        numDays: null,
        startWeekDay: null,
        resumen: []
      }
    }
  },
  created () {
    const vm = this;

    vm.axios.get('/programacion/guias', {
      params: {
        month: vm.month,
        idModule: vm.idModule,
        fields: ['calendario']
      }
    })
    .then(response => {

      let calendario = response.data.content.calendario;

      calendario = calendario.map(item => ({
        ...item,
        guiasNombres: item.guiasNombres ? JSON.parse(item.guiasNombres) : []
      }));

      vm.containers.calendario = calendario;

      let momentMonth = vm.$dayjs(vm.month, 'YYYY-MM');
      vm.containers.numDays = momentMonth.daysInMonth();

      let startWeekDay = momentMonth.startOf('month').day();
      startWeekDay = startWeekDay == 0 ? 7 : startWeekDay;
      startWeekDay = startWeekDay - 1;
      vm.containers.startWeekDay = startWeekDay;
      
      vm.loading.view = false;
    })
    .catch(error => {

    })
  },
  computed: {
    resumen () {
      const vm = this;

      let resumen = {};

      vm.containers.calendario.forEach(item => {
        item.guiasNombres.forEach(guia => {
          if (typeof resumen[guia.id] == 'undefined') {
            resumen[guia.id] = {
              name: guia.nombre,
              services: {
                city: 0,
                valle: 0,
                mapi: 0
              },
              total: 0
            }
          }

          addCount(item.servicio, resumen[guia.id]);
        })
      })

      function addCount (pIdServicio, resumen) {
        if (pIdServicio == 1) {
          resumen.services.city++;
        }else if (pIdServicio == 2) {
          resumen.services.valle++;
        }else if (pIdServicio == 3) {
          resumen.services.mapi++;
        }

        resumen.total = resumen.services.city + resumen.services.valle + resumen.services.mapi;
      }

      return Object.values(resumen);
    }
  },
  methods: {
  }
}
</script>